import { render, staticRenderFns } from "./SopTemplateContents.vue?vue&type=template&id=79d1b524&scoped=true&"
import script from "./SopTemplateContents.vue?vue&type=script&lang=ts&"
export * from "./SopTemplateContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d1b524",
  null
  
)

export default component.exports